<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(:filter.sync="nameFilter")
    filter-enabled.mr-2(:filter.sync="enabledFilter")
  v-btn.button-sm.underline.px-0(text @click="resetFilters" :disabled="allFilters.length === 0") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterEnabled from '@/components/clinic/manage/printer/FilterEnabled.vue'

export default {
  components: { FilterName, FilterEnabled },
  props: ['filters'],
  data: () => ({
    nameFilter: {},
    enabledFilter: {},
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.enabledFilter.key) {
        filters.push(this.enabledFilter)
      }
      return filters
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    resetFilters () {
      this.nameFilter = {}
      this.enabledFilter = {}
    }
  }
}
</script>